import { connect } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { deleteAccount, logout, refreshToken, confirmTel as confirmTelAction } from "../../../store/actions/userActions";
import { performAction } from "../../../store/actions/all";
import client from "../../../client";
import EventsSocket from "../../../client/Websockets/events";
import { AS_ENDPOINT } from "../../../config/constants";
import { selectLanguageOrDefault, selectUserSlice, selectUserValue } from "../../../selectors";

const mapper = (dispatch: AppDispatch) => ({
  logout: () => {
    logout(dispatch);
  },
  confirmTel: (code: string) => {
    confirmTelAction(dispatch, code);
  },
  deleteAccount: () => {
    performAction({ f: deleteAccount, p: [dispatch] });
  },
  setEndpoint: (endpoint: string) => {
    client().setEndpoint(endpoint);
    EventsSocket.setEndpoint(endpoint);
    localStorage.setItem(AS_ENDPOINT, endpoint);
    refreshToken(dispatch);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  },
});

const props = (state: RootState) => ({
  changeUsernameStatus: selectUserSlice(state).userStatus,
  user: selectUserValue(state),
  l: selectLanguageOrDefault(state),
});

export const connector = connect(props, mapper);
